var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{style:(_vm.btnStyle),attrs:{"title":_vm.title,"disabled":_vm.disabled},on:{"click":_vm.inverseValue}},[_vm._t("default",[(_vm.value)?_c('i',{staticClass:"fas fa-eye"}):_c('i',{staticClass:"far fa-eye-slash"})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }